import { faTelescope } from '@fortawesome/pro-duotone-svg-icons';
import { Skeleton } from 'antd';
import { pipe } from 'ramda';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import {
  Grid as GridAtom,
  withEditingMask,
  withExternalFilter,
  withSingleClickEdit,
} from 'components/atoms/grid';
import { withStylePreferenceProvider } from 'components/atoms/style-preference-context';
import { withStatusBar } from 'components/organisms/task-grid/plugins';
import { Overlay } from '../components';

const Grid = styled(GridAtom)`
  .ag-row {
    border-color: var(--table-border-color);
  }
  .ag-react-container {
    max-width: 100%;
  }
  .multiline-text {
    max-height: var(--height-lg);
    padding-top: var(--spacing-02);
    white-space: pre-wrap;
    line-height: var(--spacing-07);
  }
  .ag-row-group-leaf-indent.ag-row-group-indent-0 {
    padding-left: 0 !important;
  }
  .task-grid-row-private {
    --ag-odd-row-background-color: var(--private-01);
    --ag-background-color: var(--private-01);
    --ag-row-hover-color: var(--private-02);
  }
`;

export const Wrapper = styled.div`
  padding-left: var(--left-spacing);
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: stretch;
`;

export const GridContainer = styled.div`
  flex: 1 1 100%;

  /** TODO: Fix ant input number, remove quick fix */
  .ant-input-number {
    border: 1px solid transparent !important;
    box-shadow: none;

    input {
      text-align: right;
      padding-right: var(--layout-02);
    }
  }

  &.multi-select .ag-selection-checkbox {
    opacity: 1;
  }
`;

export const StyledGrid = pipe(
  pipe(
    () => Grid,
    withExternalFilter,
    withSingleClickEdit,
    withStatusBar,
    withStylePreferenceProvider({ size: 'middle' }),
    withEditingMask,
  ),
)();

const Loading = styled(Skeleton)`
  margin-left: var(--layout-03);
`;

export const LoadingCell = memo(() => (
  <Loading title paragraph={false} active />
));

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  display: flex;
  align-self: center;
  padding: 0;
  position: absolute;
  left: 6rem;
`;

export const AllTasksEmptyState = () => {
  return (
    <Overlay>
      <EmptyStateContainer>
        <EmptyState
          image={<EmptyStateIcon icon={faTelescope} />}
          title={<FormattedMessage id="home.no_results.empty.title" />}
          message={<FormattedMessage id="home.no_results.empty.message" />}
          secondaryCTA={null}
        />
      </EmptyStateContainer>
    </Overlay>
  );
};
